module.exports = __webpack_public_path__ + "img/bs_logo.7274e632.png";